import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useAuthState } from 'react-firebase-hooks/auth'; // Import the hook here
import { auth } from './firebaseConfig'; // Make sure the correct path for firebaseConfig is used
import { ThemeProvider } from './context/ThemeContext';

import './index.css';
import App from './components/App';
import LandingPage from './components/LandingPage';
import MakeYourOwnTest from './components/MakeYourOwnTest';
import MockTest from './components/MockTest';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import AttemptedQuestionsPage from './components/Main/attempted';
import UserProfile from '././components/Profile';
import PlansBillingSection from './components/plansandbilling/plansandbilling';
import AdminPanel from './components/AdminPanel';
import { trackSiteVisit } from './utils/metrics';


const root = ReactDOM.createRoot(document.getElementById('root'));

trackSiteVisit();

root.render(
  <ThemeProvider>
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/quiz-app" element={<App />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/make-your-own-test" element={<MakeYourOwnTest />} />
          <Route path="/mock-test" element={<MockTest />} />
          <Route path="/attempted-questions" element={<AttemptedQuestionsPage />} />
          <Route path="/plans-billing" element={<PlansBillingSection />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route
            path="/profile"
            element={
              <AppWithUserProfile /> // Pass the component here with the user data
            }
          />
        </Routes>
      </Router>
    </HelmetProvider>
  </ThemeProvider>
);

function AppWithUserProfile() {
  const [user, loading, error] = useAuthState(auth); // Move the hook call inside the component

  // If the user is not authenticated or data is still loading
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return <UserProfile user={user} />; // Pass the `user` object as a prop to UserProfile
}

// Register the service worker
serviceWorkerRegistration.register();
